import { Injectable, Provider } from "@angular/core";
import { Observable, forkJoin, of } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { AuthService as MainAuthService, AuthType, IDENEDI_CODE_STORAGE_KEY } from "src/app/shared/services/auth.service";
import { IStemexeModule } from "../data-providers/interfaces/interfaces";
import { StemexeDataProviderService } from "../data-providers/services/stemexe-data-provider.service";
import { DataProvider, PagedData, PagedDataItem } from "../data-providers/models/models";
import { environment } from "src/environments/environment";
import { AuthService } from "./shared/services/auth.service";

//EspDataProviderService class and it's usage is only for demo purpose.
@Injectable({
  providedIn: "root"
})
export class PlannexeDataProviderService implements IStemexeModule {
  type: AuthType = AuthType.EngagementPro;

  constructor(
    private _stemexeHost: StemexeDataProviderService,
    private http: HttpClient,
    private authService: AuthService,
    private _authService: MainAuthService
  ) {
  }

  initialize(): void {
  }

  getDataProviders(providerType: string): Observable<DataProvider[]> {
    let espDataProviders: DataProvider[] = [];
    if (providerType == 'ActivitySource') {
      return this._authService.getAuthAddonByType(AuthType.Plannexe).pipe(
        switchMap(addon => {
          let pDataProvider: DataProvider = new DataProvider();
          pDataProvider.title = 'PlanneXe';
          pDataProvider.id = '5';
          pDataProvider.system = addon?.BaseUrl
          pDataProvider.tenantId = this.authService.organizationId.toString();
          pDataProvider.getData = (token, isAll) => {
            return this._getProviderData(pDataProvider, token, isAll)
          }
          espDataProviders.push(pDataProvider);
          return of(espDataProviders);
          }));
        }
  }
  private _getProviderData(provider: DataProvider, nextPageToken?: any, isAll?: any): Observable<PagedData> {
    // console.log('token', nextPageToken)
    if (provider.id === '5') {
      return this.getPlannexeBaseUrl().pipe(
        switchMap(baseUrl => {
          const url = isAll ? `${baseUrl}/api/Project/GetAllProjectsMini` : `${baseUrl}/api/Project/GetAllProjectsMiniAll`;
          return this.http.post(url, {}, this.getURLHeaders());
        }),
        map((result: any) => {
          let pagedData = new PagedData();
          pagedData.items = result.result.map((r: any) => {
            let item1 = new PagedDataItem();
            item1.id = r.projectId;
            item1.extraData = {}
            item1.title = r.projectName,
              item1.url = '/pages/engagement/project/' + r.projectId;
            item1.getData = (nextPageToken) => this._getNextData(provider, item1, nextPageToken);
            item1.isSimpleProject = r.isSimpleProject;
            return item1;
          })
          return pagedData;
        })
      );
    }
    else {
      let pagedData = new PagedData();
      return of(pagedData);
    }
  }
  private _getNextData(provider: DataProvider, pagedDataItem: PagedDataItem, nextPageToken?: any) {
    const data = {
      projectId: pagedDataItem.id,
      isFilterApplied: false,
      filterObject: {
        labels: [],
        priority: []
      },
      viewGroupType: 0,
      applyExtrafilterObject: false,
      extrafilterObject: {
        priority: 0,
        state: 0
      },
      pageNum: 0,
      pageSize: 20,
      search: pagedDataItem.keyword ? pagedDataItem.keyword : '',
    };
    return this.getPlannexeBaseUrl().pipe(
      switchMap(baseUrl => this.http.post(baseUrl + '/api/Requirements/GetAllRequirements', data, this.getURLHeaders())),
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.result.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.requirementId;
          item1.extraData = {
            deliverables: r.deliverables
          }
          item1.title = r.title,
            item1.url = '/pages/engagement/project/' + r.projectId + '/requirements';
          item1.getData = (nextPageToken) => this._getDeliverableData(provider, item1, nextPageToken);
          return item1;
        })
        return pagedData;
      })
    );
  }
  private _getDeliverableData(provider: DataProvider, pagedDataItem: PagedDataItem, nextPageToken?: any) {
    console.log('_getDeliverableData', provider, pagedDataItem, nextPageToken);
    let pagedData = new PagedData();
    pagedData.items = pagedDataItem.extraData.deliverables.map((del: any) => {
      let item1 = new PagedDataItem();
      item1.id = del.deliverableId;
      item1.extraData = {}
      item1.title = 'DV' + del.deliverableId + ' - ' + (del.stageName ? del.stageName : 'No Stage') + ' - ' + (del.platformName ? del.platformName : 'No Platform'),
      item1.url = '/pages/engagement/project/list';
      item1.getData = (nextPageToken) => this._getDeliverableData(provider, item1, nextPageToken);
      return item1;
    });
    return of(pagedData);
  }
  openUrl(url: string, context: any): any {
    if (url === '/pages/engagement/') {
      //asdf
    }
  }

  // Group's (tenant) PlanneXe addon BaseUrl, e.g. FCSC ka apna API; environment base sirf fallback ha
  getPlannexeBaseUrl(): Observable<string> {
    return this._authService.getAuthAddonByType(AuthType.EngagementPro).pipe(
      map(addon => addon?.BaseUrl || environment.plannexe.baseURL),
      catchError(() => of(environment.plannexe.baseURL))
    );
  }

  getURLHeaders(): any {
    return {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + this.authService.token
      })
    }
  }
}